<template>
  <router-link :to="localizedPath" class="main-button">
    <span class="button-text">
      {{ buttonText }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'MainButton',
  props: {
    buttonText: {
      type: String,
      required: true
    },
    targetRoute: {
      type: String,
      required: true
    }
  },
  computed: {
    localizedPath() {
      return {
        name: this.targetRoute,  
        params: { locale: this.$i18n.locale } 
      };
    }
  }
}
</script>
